import { Skeleton } from '../../../../Skeleton'

import * as styles from './RequestProfileTabRatingCardSkeleton.module.css'

function RequestProfileTabRatingCardSkeleton() {
  return (
    <div className={styles.skeleton}>
      <div className={styles.header}>
        <Skeleton className={styles.avatar} />
        <Skeleton className={styles.name} />
      </div>
      <Skeleton className={styles.line} />
      <Skeleton className={styles.lineWide} />
      <Skeleton className={styles.line} />
      <Skeleton className={styles.lineFull} />
      <Skeleton className={styles.image} />
      <div className={styles.footer}>
        <Skeleton className={styles.footerItem} />
        <Skeleton className={styles.footerItemSmall} />
      </div>
      <Skeleton className={styles.bottomLine} />
    </div>
  )
}

export default RequestProfileTabRatingCardSkeleton
